import { Injectable, NgZone } from '@angular/core';

import { AuthenticationService } from '../services/authentication/authentication.service';
import { ExtensaService } from './extensa.service';

@Injectable({
    providedIn: 'root',
})
export class WpfService {
    hub: SignalR.Hub.Proxy;
    constructor(
        private extensaService: ExtensaService,
        private authentication: AuthenticationService,
        private zone: NgZone,
    ) {}

    async initService() {
        if (this.hub) {
            return;
        }

        this.hub = this.extensaService.signalrHubConnection.createHubProxy('EstensaWpfHub');

        this.listenForEstensaWpfEvents(this.hub);
    }

    private listenForEstensaWpfEvents(hub: SignalR.Hub.Proxy) {
        hub.on('windowMessage', (msg) => this.zone.run(() => this.onWindowMessage(), this, [msg]));
    }

    private onWindowMessage() {
        location.reload();
    }

    async webClientClosing?(msg: string): Promise<void> {
        if (this.authentication.isOpenedFromWpf) {
            this.hub.invoke('WebClientClosing', msg);
        }
    }
}
